import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.4444 13.5556L18 10M18 10L14.4444 6.44444M18 10H6.44444M10.8889 15.3333C10.8889 16.0406 10.6079 16.7189 10.1078 17.219C9.60774 17.719 8.92947 18 8.22222 18H4.66667C3.95942 18 3.28115 17.719 2.78105 17.219C2.28095 16.7189 2 16.0406 2 15.3333V4.66667C2 3.95942 2.28095 3.28115 2.78105 2.78105C3.28115 2.28095 3.95942 2 4.66667 2H8.22222C8.92947 2 9.60774 2.28095 10.1078 2.78105C10.6079 3.28115 10.8889 3.95942 10.8889 4.66667" stroke="#F32D2D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;